import { render, staticRenderFns } from "./LocationTagsList.vue?vue&type=template&id=44d2d0ff&scoped=true&"
import script from "./LocationTagsList.vue?vue&type=script&lang=ts&"
export * from "./LocationTagsList.vue?vue&type=script&lang=ts&"
import style0 from "./LocationTagsList.vue?vue&type=style&index=0&id=44d2d0ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2d0ff",
  null
  
)

export default component.exports